import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Queries data
  queries: [],
  selectedQuery: null,
  loading: false,
  error: null,
  successMessage: null,

  // Statistics
  statistics: {
    successfulQueriesToday: 0,
    failedQueriesToday: 0,
    averageResponseTimeMs: 0,
    successRateLast24Hours: 0,
    totalQueriesLast24Hours: 0,
    totalQueriesThisMonth: 0,
    pendingQueries: 0,
  },
  statisticsLoading: false,

//   // Configuration
//   configuration: null,
//   configurationLoading: false,

  // Pagination
  page: 1,
  pageSize: 10,
  total: 0,

  // Sorting
  sortColumn: 'createdon',
  sortDirection: 'desc',

  // Filtering
  filterDeviceId: '',
  filterUnitName: '',
  filterQueryType: '',
  filterStatus: '',
  filterSecurityLevel: '',
  filterStartDate: null,
  filterEndDate: null,
};

const verificationQueriesSlice = createSlice({
  name: 'verificationQueries',
  initialState,
  reducers: {
    // Fetch queries
    fetchQueries: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchQueriesSuccess: (state, action) => {
      state.loading = false;
      state.queries = action.payload.data;
      state.total = action.payload.meta.total;
      state.error = null;
    },
    fetchQueriesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Fetch query by ID
    fetchQueryById: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchQueryByIdSuccess: (state, action) => {
      state.loading = false;
      state.selectedQuery = action.payload;
      state.error = null;
    },
    fetchQueryByIdFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Create query
    createQuery: (state) => {
      state.loading = true;
      state.error = null;
    },
    createQuerySuccess: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload.message;
      state.error = null;
    },
    createQueryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Update query
    updateQuery: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateQuerySuccess: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload.message;
      state.error = null;
    },
    updateQueryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Delete query
    deleteQuery: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteQuerySuccess: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload.message;
      state.error = null;
    },
    deleteQueryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Fetch statistics
    fetchStatistics: (state) => {
      state.statisticsLoading = true;
    },
    fetchStatisticsSuccess: (state, action) => {
      state.statisticsLoading = false;
      state.statistics = action.payload;
    },
    fetchStatisticsFailure: (state, action) => {
      state.statisticsLoading = false;
      state.error = action.payload;
    },

    // Fetch configuration
//     fetchConfiguration: (state) => {
//       state.configurationLoading = true;
//     },
//     fetchConfigurationSuccess: (state, action) => {
//       state.configurationLoading = false;
//       state.configuration = action.payload;
//     },
//     fetchConfigurationFailure: (state, action) => {
//       state.configurationLoading = false;
//       state.error = action.payload;
//     },
// 
//     // Update configuration
//     updateConfiguration: (state) => {
//       state.configurationLoading = true;
//       state.error = null;
//     },
//     updateConfigurationSuccess: (state, action) => {
//       state.configurationLoading = false;
//       state.configuration = action.payload;
//       state.successMessage = 'Configuration updated successfully';
//       state.error = null;
//     },
//     updateConfigurationFailure: (state, action) => {
//       state.configurationLoading = false;
//       state.error = action.payload;
//     },

    // Pagination
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
      state.page = 1;
    },

    // Sorting
    setSortColumn: (state, action) => {
      state.sortColumn = action.payload;
    },
    setSortDirection: (state, action) => {
      state.sortDirection = action.payload;
    },

    // Filtering
    setFilterDeviceId: (state, action) => {
      state.filterDeviceId = action.payload;
      state.page = 1;
    },
    setFilterUnitName: (state, action) => {
      state.filterUnitName = action.payload;
      state.page = 1;
    },
    setFilterQueryType: (state, action) => {
      state.filterQueryType = action.payload;
      state.page = 1;
    },
    setFilterStatus: (state, action) => {
      state.filterStatus = action.payload;
      state.page = 1;
    },
    setFilterSecurityLevel: (state, action) => {
      state.filterSecurityLevel = action.payload;
      state.page = 1;
    },
    setFilterStartDate: (state, action) => {
      state.filterStartDate = action.payload;
      state.page = 1;
    },
    setFilterEndDate: (state, action) => {
      state.filterEndDate = action.payload;
      state.page = 1;
    },
    clearFilters: (state) => {
      state.filterDeviceId = '';
      state.filterUnitName = '';
      state.filterQueryType = '';
      state.filterStatus = '';
      state.filterSecurityLevel = '';
      state.filterStartDate = null;
      state.filterEndDate = null;
      state.page = 1;
    },

    // Clear messages
    clearError: (state) => {
      state.error = null;
    },
    clearSuccessMessage: (state) => {
      state.successMessage = null;
    },
  },
});

export const {
  fetchQueries,
  fetchQueriesSuccess,
  fetchQueriesFailure,
  fetchQueryById,
  fetchQueryByIdSuccess,
  fetchQueryByIdFailure,
  createQuery,
  createQuerySuccess,
  createQueryFailure,
  updateQuery,
  updateQuerySuccess,
  updateQueryFailure,
  deleteQuery,
  deleteQuerySuccess,
  deleteQueryFailure,
  fetchStatistics,
  fetchStatisticsSuccess,
  fetchStatisticsFailure,
//   fetchConfiguration,
//   fetchConfigurationSuccess,
//   fetchConfigurationFailure,
//   updateConfiguration,
//   updateConfigurationSuccess,
//   updateConfigurationFailure,
  setPage,
  setPageSize,
  setSortColumn,
  setSortDirection,
  setFilterDeviceId,
  setFilterUnitName,
  setFilterQueryType,
  setFilterStatus,
  setFilterSecurityLevel,
  setFilterStartDate,
  setFilterEndDate,
  clearFilters,
  clearError,
  clearSuccessMessage,
} = verificationQueriesSlice.actions;

// Selectors
export const selectQueries = (state) => state.verificationQueries?.queries || [];
export const selectSelectedQuery = (state) => state.verificationQueries?.selectedQuery;
export const selectQueriesLoading = (state) => state.verificationQueries?.loading || false;
export const selectQueriesError = (state) => state.verificationQueries?.error;
export const selectQueriesSuccessMessage = (state) => state.verificationQueries?.successMessage;
export const selectQueriesTotal = (state) => state.verificationQueries?.total || 0;
export const selectQueriesPage = (state) => state.verificationQueries?.page || 1;
export const selectQueriesPageSize = (state) => state.verificationQueries?.pageSize || 10;
export const selectQueriesSortColumn = (state) => state.verificationQueries?.sortColumn || 'createdon';
export const selectQueriesSortDirection = (state) => state.verificationQueries?.sortDirection || 'desc';
export const selectStatistics = (state) => state.verificationQueries?.statistics || {};
export const selectStatisticsLoading = (state) => state.verificationQueries?.statisticsLoading || false;
// export const selectConfiguration = (state) => state.verificationQueries?.configuration;
// export const selectConfigurationLoading = (state) => state.verificationQueries?.configurationLoading || false;

// Filter selectors
export const selectFilterDeviceId = (state) => state.verificationQueries?.filterDeviceId || '';
export const selectFilterUnitName = (state) => state.verificationQueries?.filterUnitName || '';
export const selectFilterQueryType = (state) => state.verificationQueries?.filterQueryType || '';
export const selectFilterStatus = (state) => state.verificationQueries?.filterStatus || '';
export const selectFilterSecurityLevel = (state) => state.verificationQueries?.filterSecurityLevel || '';
export const selectFilterStartDate = (state) => state.verificationQueries?.filterStartDate;
export const selectFilterEndDate = (state) => state.verificationQueries?.filterEndDate;

export default verificationQueriesSlice.reducer;
